import React, { useId } from 'react';

/** Small flag glyph (SVG, renders consistently on every OS unlike emoji flags). */
export function Flag({
  code,
  className = 'w-5 h-[14px]'
}: {
  code: 'fr' | 'gb';
  className?: string;
}) {
  const id = useId().replace(/:/g, '');
  if (code === 'fr') {
    return <svg viewBox="0 0 3 2" className={`${className} rounded-[2px] ring-1 ring-black/10 shrink-0`} aria-hidden="true" data-id="element-7830" data-mp="1y4ltaszvk0z8">
        <rect width="1" height="2" fill="#002654" data-id="element-7831" data-mp="2346pivnntv89" />
        <rect x="1" width="1" height="2" fill="#FFFFFF" data-id="element-7832" data-mp="231km987sy1vu" />
        <rect x="2" width="1" height="2" fill="#CE1126" data-id="element-7833" data-mp="281q4xyw3ge1s" />
      </svg>;
  }
  return <svg viewBox="0 0 60 30" preserveAspectRatio="none" className={`${className} rounded-[2px] ring-1 ring-black/10 shrink-0`} aria-hidden="true" data-id="element-7834" data-mp="2ct86op5xyint">
      <clipPath id={`s${id}`} data-id="element-7835" data-mp="2hrrxp3ze6kn1">
        <path d="M0,0 v30 h60 v-30 z" data-id="element-7836" data-mp="2lug3t3wq1dgb" />
      </clipPath>
      <clipPath id={`t${id}`} data-id="element-7837" data-mp="2lvr58x2p2949">
        <path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" data-id="element-7838" data-mp="2qt97y5q4bs3t" />
      </clipPath>
      <g clipPath={`url(#s${id})`} data-id="element-7839" data-mp="2qqwrxy3x7rte">
        <path d="M0,0 v30 h60 v-30 z" fill="#012169" data-id="element-7840" data-mp="2185fj5xa603v" />
        <path d="M0,0 L60,30 M60,0 L0,30" stroke="#FFFFFF" strokeWidth="6" data-id="element-7841" data-mp="215j7742kfgkl" />
        <path d="M0,0 L60,30 M60,0 L0,30" clipPath={`url(#t${id})`} stroke="#C8102E" strokeWidth="4" data-id="element-7842" data-mp="1x4h4uedcqoee" />
        <path d="M30,0 v30 M0,15 h60" stroke="#FFFFFF" strokeWidth="10" data-id="element-7843" data-mp="1s7h7qsyhcvzf" />
        <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" data-id="element-7844" data-mp="1n8w92xyvmkd3" />
      </g>
    </svg>;
}